import { animate, style, transition, trigger } from '@angular/animations';
import { isSSA } from '@shared/helpers/is-ssa/is-ssa';

/**
 * Toast fade-in fade-out animation
 */
export const TOAST_FADE_IN_TIME = 120;
export const TOAST_FADE_OUT_TIME = isSSA() ? 0 : 1200;
export const toastFadeInOutAnimation = [
  trigger('fadeInOut', [
    transition(':enter', [
      style({ opacity: 0 }),
      animate(TOAST_FADE_IN_TIME, style({ opacity: 1 })),
    ]),
    transition(':leave', [animate(TOAST_FADE_OUT_TIME, style({ opacity: 0 }))]),
  ]),
];
